import { render } from "./BuildIcon6.vue?vue&type=template&id=1f0918ec&scoped=true"
import script from "./BuildIcon6.vue?vue&type=script&lang=js"
export * from "./BuildIcon6.vue?vue&type=script&lang=js"

import "./BuildIcon6.vue?vue&type=style&index=0&id=1f0918ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0918ec"]])

export default __exports__